
<template>
  <v-dialog     scrollable persistent v-model="accounts.modals.modifier" width="950"   >
  <v-card  >
    <v-toolbar dark  color="#4A76A8" flat  height="42">
      <v-toolbar-title  >  Модификация аккаунтов : {{selecta}}   </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click="accounts.modals.modifier = false">mdi-close</v-icon>
    </v-toolbar>

  <v-card-text>




  <div style="height:5px"></div>
  <v-layout justify-space-between>




  <div style="width:950px">


  <v-layout>

     <v-expansion-panel
        expand focusable
      >



      <v-expansion-panel-content >


            <div slot="header" style="color:#757575;font-size:1.3em ">
             Изменить прокси
           </div>


        <v-card>
          <v-card-text>
            <div >
              <v-checkbox label="Удалить старый прокси" v-model="modifyArr.proxy.del"></v-checkbox>
              <v-textarea        color="#4A76A8"
              placeholder="Действует рандомное распределение прокси между добавляемыми аккаунтами"
                v-model="modifyArr.proxy.proxyList"
                box
              label=" ip:port:login:pass (на каждую строку)"
              >

              </v-textarea>

            </div>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>


        <v-expansion-panel-content >


              <div slot="header" style="color:#757575;font-size:1.3em ">
               Личные данные
             </div>


          <v-card>
            <v-card-text>
              <div >
                <v-text-field v-model="modifyArr.info.name"     hint="Имя и Фамилия с большой буквы " label="Имя и Фамилия" clearable> </v-text-field>
                <v-text-field v-model="modifyArr.info.age"     hint="Дата рождения пользователя в формате DD.MM.YYYY, например  15.11.1994"    label="Дата рождения" clearable> </v-text-field>
                <v-text-field v-model="modifyArr.info.ava"      hint="Картинка которая лежит в vkback/resources/accounts/img  например photo.png " label="Аватарка" clearable> </v-text-field>

              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>






        <v-expansion-panel-content >


              <div slot="header" style="color:#757575;font-size:1.3em ">
               Приватность
             </div>


          <v-card>
            <v-card-text>
              <div >
      <v-checkbox v-model="modifyArr.privat.changePass"      hint="Пароль поменяется на рандомный" label="Сменить пароль ?" clearable> </v-checkbox>
              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>







        <v-expansion-panel-content >


              <div slot="header" style="color:#757575;font-size:1.3em ">
               Пост, Статус
             </div>


          <v-card>
            <v-card-text>
              <div >

                       <v-checkbox
                    label="Изменить статусную строку ?"
                    v-model="modifyArr.posting.status.active"
                       ></v-checkbox>

                       <div v-if="modifyArr.posting.status.active">
                <v-text-field  v-model="modifyArr.posting.status.text" hint="Текст статусной строки" label="Статус" clearable><v-icon  slot="prepend">mdi-message</v-icon></v-text-field>
              </div>

           <v-checkbox
        label="Создать пост ?"
        v-model="modifyArr.posting.post.active"
           ></v-checkbox>

           <div v-if="modifyArr.posting.post.active">
                <v-textarea
                 v-model="modifyArr.posting.post.text"
                 label="Текс поста"
                 hint="Самый обычный текст  "
                >

                </v-textarea>

                <v-checkbox
           label="Закрепить пост ?"
            v-model="modifyArr.posting.post.pin"
                ></v-checkbox>

           </div>





              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>


     </v-expansion-panel >


  </v-layout>










  <v-layout >
  <v-btn  @click="accounts.modals.modifier = false"    block color="red" class="white--text" ><v-icon left>mdi-close</v-icon> Отмена</v-btn>
  <div style="width:10px"></div>
  <v-btn :loading="animateMody"  @click="modyGo()"  block color="#4A76A8" class="white--text"> <v-icon left> mdi-content-copy</v-icon> Модифицировать </v-btn>
  </v-layout>

  </div>





  </v-layout>
  </v-card-text>

  </v-card>
  </v-dialog>


</template>

<script>

import axios from 'axios'

export default {

props:['accounts','selecta'],
  data () {
    return {
      animateMody: false,
      modifyArr : {
        info: {
          name: "",
          age: "",
          ava: "",
        },

        privat: {
          changePass:false,

        },

        posting: {

         repost: "",
         repostText : "",

      post : {
         active: false,
         text: "",
         photo: "",
         pin : true,
      },


         status: {
           active: false,
           text: "",
         },

        },
        proxy: {
            del:false,
            proxyList:"",
              },

      },
    }
  },
methods:{
  modyGo (){
   this.animateMody = true
   let aki = this.accounts.accGroups.list.filter((item,i,arr)=>{
     return item.selected
   })
      axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/modify.php', {
           method: 'POST',
           data: {
             accounts: aki,
             moda:this.modifyArr,
           }
         }).then(response => {
           this.animateMody = false
           this.accounts.modals.modifier = false

         })
    },

},
computed: {
},
created(){

},

}
</script>

<style   >

</style>
